<router-outlet/>

<app-loader/>

<app-http-error-message/>

<app-assistant-widget/>
